import styled from "styled-components";
import React from "react";
import { COLORS } from "../contants/colors";
import MorePopover from "./MorePopover";
import { useState } from "react";
import { useLanguageContext } from "../languageContext";

const Alert = ({
  Highlighted= false,
  canDelete=true,
  photo,
  title,
  subtitle,
  address,
  time,
  participants,
  disapprovers,
  onDelete,
  onOpenParticipants,
  onOpenDisapprovers,
  user=null,
  onSelectUser,
  showPin=false,
  onPinALert,
  isPinned
}) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { t } = useLanguageContext();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };
  return (
    <Wrapper active={Highlighted} pinned={isPinned}>
      <MorePopover
        canDelete={canDelete}
        onDelete={onDelete}
        showEdit={false}
        handleClick={handleClick}
        open={open}
        setOpen={setOpen}
        anchorEl={anchorEl}
        showPin={showPin}
        onPinALert={onPinALert}
        isPinned={isPinned}
      />
      <Row>
        <Avatar
          src={photo !== "" ? photo : require("../images/avatar.svg").default}
          onClick={()=>onSelectUser(user)}
        />
        <div>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </div>
      </Row>
      <SubRow>
        <p style={{ margin: 0 }}>
          <Icon src={require("../images/pin.svg").default} alt="" />
          {address}
        </p>
        <p style={{ margin: 0 }}>
          <Icon src={require("../images/timer.svg").default} alt="" />
          {time}
        </p>
      </SubRow>
      <Divider />
      <Button pinned={isPinned} onClick={onOpenParticipants}>{`${t(
        "nbrAssis"
      )}:  ${participants} `}</Button>
      <SecondaryBtn pinned={isPinned} onClick={onOpenDisapprovers}>{`${t(
        "nbrNay"
      )}:  ${disapprovers} `}</SecondaryBtn>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  color: ${COLORS.black56};
  border-radius: 10px;
  font-family: "Din";
  // text-align: left;
  font-size: 0.75rem;
  padding: 10px 18px;
  box-shadow: 0 30px 60px rgba(57, 57, 57, 0.1);
  position: relative;
  background-color: ${p=>p.pinned? COLORS.lightOrange :p.active ? COLORS.blue3:  "white"};
  border: 1.5px solid ${p=>p.pinned? COLORS.orange10 : p.active ? COLORS.blue4:  COLORS.background};
  cursor: pointer;
`;

const Button = styled.button`
  color: white;
  border-radius: 4px;
  font-family: "Din";
  font-size: 0.75rem;
  font-weight: 700;
  background-color:  ${p=>p.pinned? COLORS.orange : COLORS.primary};
  border: none;
  height: 38px;
  margin-top: 18px;
  width: 100%;

  &:focus {
    outline-color: ${p=>p.pinned? COLORS.orange :COLORS.primary};
  }
`;
const SecondaryBtn = styled(Button)`
  background-color: ${p=>p.pinned? COLORS.orange20 :COLORS.green30};
  color: ${p=>p.pinned? COLORS.orange :COLORS.primary};
`;
const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${COLORS.gray300};
  margin: 5px 0;
`;

const Row = styled.div`
  display: flex;
  padding-top: 20px;
  align-items: center;
`;
const SubRow = styled.div`
  display: flex;
  margin: 25px 0 10px 0;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  font-size: 0.75rem;
  color: black;
`;
const Icon = styled.img`
  height: 12px;
  object-fit: cover;
  margin-right: 6px;
  margin-bottom: 4px;
`;
const Avatar = styled.img`
  border-radius: 50%;
  height: 60px;
  min-width: 60px;
  object-fit: cover;
  margin-right: 10px;
`;
const Title = styled.p`
  font-weight: 700;
  font-size: 0.9375rem;
  color: ${COLORS.black27};
  margin: 0 5px 0 0;
  padding-bottom: 3px;
`;
const Subtitle = styled.p`
  font-weight: 400;
  font-size: 0.8125rem;
  color: ${COLORS.gray97};
  margin: 0 5px 0 0;
  /* text-overflow: ellipsis; */
  /* word-break: break-all; */

  /* overflow: hidden;
  white-space: nowrap;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical; */
`;
export default Alert;
